import axios from 'axios'
import { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import adminsHeader from './adminsHeader'
import AsideModal from '../../Common/AsideModal/AsideModal'
import EditAdmin from './EditAdmin'
import { Modal, Button } from 'react-bootstrap'
import sweetAlert from 'sweetalert'
import './Admin.scss'

const Admin = () => {
  const [data, setData] = useState([])
  const [active, setActive] = useState({})
  const [keyWord, setKeyWord] = useState('')
  const [actionType, setActionType] = useState('edit')
  const [showAsideModal, setShowAsideModal] = useState(false)
  const [showDeleteAdminModal, setShowDeleteAdminModal] = useState(false)
  const [initialAdminFormValue, setInitialAdminFormValue] = useState({
    username: '',
    name: '',
    surname: '',
    country: '',
    city: '',
    copartAccount: '',
    iaaiAccount: '',
    phone: '',
    email: '',
    role: 'admin',
    password: '',
    status: '',
  })

  useEffect(() => {
    axios(process.env.REACT_APP_BASE_URL + `/api/admins`)
      .then(response => {
        const admins = response.data.data

        setData([...admins])
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  const handlers = {
    editAdmin(admin) {
      setShowAsideModal(true)
      setActionType('edit')
      setInitialAdminFormValue({
        username: admin.username,
        name: admin.name,
        surname: admin.surname,
        country: admin.country,
        city: admin.city,
        copartAccount: admin.copartAccount,
        iaaiAccount: admin.iaaiAccount,
        phone: admin.phone,
        email: admin.email,
        role: 'admin',
        status: admin.status,
        password: admin.password,
      })
      setActive({ ...admin })
    },
    addAdmin() {
      setShowAsideModal(true)
      setActionType('add')
      setInitialAdminFormValue({
        username: '',
        name: '',
        surname: '',
        country: '',
        city: '',
        copartAccount: '',
        iaaiAccount: '',
        phone: '',
        email: '',
        role: 'admin',
        status: '',
      })
    },
    deleteAdmin(admin) {
      setShowDeleteAdminModal(true)
      setActive({ ...admin })
    },
    saveAdminData(adminFormValue) {
      axios
        .put(process.env.REACT_APP_BASE_URL + `/api/admin/${active.id}`, adminFormValue)
        .then(response => {
          const edit = response.data.data
          const updateAdmin = data.map(a => {
            if (active.id === a.id) {
              return { ...edit, usersCount: active.usersCount }
            } else {
              return a
            }
          })

          setData([...updateAdmin])
          setShowAsideModal(false)
        })
        .catch(err => {
          sweetAlert('Error', 'Failed to update admin', 'error')
        })
    },
    createNewAdmin(adminFormValue) {
      axios
        .post(process.env.REACT_APP_BASE_URL + `/api/admin`, adminFormValue)
        .then(response => {
          const admin = response.data
          setData(prev => {
            return [admin, ...prev]
          })
          setShowAsideModal(false)
        })
        .catch(err => {
          sweetAlert('Error', 'Failed to create admin', 'error')
        })
    },
    delete() {
      axios
        .delete(process.env.REACT_APP_BASE_URL + `/api/admin/${active.id}`)
        .then(() => {
          const renewUsers = data.filter(a => a.id !== active.id)
          setData(renewUsers)
          setShowDeleteAdminModal(false)
        })
        .catch(err => {
          sweetAlert('Error', 'Failed to delete admin', 'error')
        })
    },
  }

  return (
    <div className="users-table">
      <div className="filters-container">
        <div>
          <input
            type="text"
            className="search-form"
            style={{ width: '380px' }}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                setKeyWord(e.target.value)
              }
            }}
            placeholder="Enter keyword"
          />
        </div>
        <div className="main-actions">
          <button className="action-main-buttons" onClick={handlers.addAdmin}>
            Add new
          </button>
        </div>
      </div>

      <Modal show={showDeleteAdminModal} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header>
          <div className="modal-title h4">Delete admin</div>
        </Modal.Header>
        <Modal.Body>
          <p> Are you sure you want to proceed?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => {
              setShowDeleteAdminModal(false)
            }}
          >
            {' '}
            Cancel
          </button>
          <Button variant="info" onClick={handlers.delete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {showAsideModal && (
        <AsideModal visible={showAsideModal} size={'400px'} title="Edit admin" setVisible={setShowAsideModal}>
          <EditAdmin
            initialFormValue={initialAdminFormValue}
            dataSetter={setInitialAdminFormValue}
            action={actionType}
            onSave={handlers.saveAdminData}
            onAdd={handlers.createNewAdmin}
          />
        </AsideModal>
      )}

      <DataTable
        className='new-table'
        columns={adminsHeader(handlers.editAdmin, handlers.deleteAdmin)}
        data={data}
        pagination
      />
    </div>
  )
}

export default Admin
